import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPractice } from 'actions/practice';
import {
  getUploadSignature,
  postCorrectionImage,
  postCorrection,
  postRepeat,
  getRepeatDetail,
  postRepeatAnswer,
  postRepeatComplete,
} from 'actions/record';
import Repeat from 'components/repeat';

// 跟读
class RepeatContainer extends Component {
  render() {
    return (
      <Repeat {...this.props} />
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  getPractice,
  getUploadSignature,
  postCorrectionImage,
  postCorrection,
  postRepeat,
  getRepeatDetail,
  postRepeatAnswer,
  postRepeatComplete,
})(RepeatContainer);



// WEBPACK FOOTER //
// ./src/containers/repeat.js